import {Trans} from "@lingui/macro";
import React from "react";
import {typeValuesListItem} from "../components/UI/SelectBox/SelectBox";

export enum PRODUCT_OWNER {
    BUY_SELL = 'BUY_SELL',
    SELF_MADE = 'SELF_MADE',
    SERVICE_PROVIDER = 'SERVICE_PROVIDER'
}

export const getProductOwnerTransComponent = (productOwner: string) => {
    switch (productOwner) {
        case PRODUCT_OWNER.BUY_SELL:
            return <Trans>Buy-Sell</Trans>
        case PRODUCT_OWNER.SELF_MADE:
            return ( <Trans>Self made</Trans> )
        case PRODUCT_OWNER.SERVICE_PROVIDER:
            return ( <Trans>Service provider</Trans> )
        default   :
            return productOwner
    }
}


export const selectProductOwnerList: typeValuesListItem[] = [
    {id: PRODUCT_OWNER.BUY_SELL, name: getProductOwnerTransComponent(PRODUCT_OWNER.BUY_SELL)},
    {id: PRODUCT_OWNER.SERVICE_PROVIDER, name: getProductOwnerTransComponent(PRODUCT_OWNER.SERVICE_PROVIDER)},
    {id: PRODUCT_OWNER.SELF_MADE, name: getProductOwnerTransComponent(PRODUCT_OWNER.SELF_MADE)},
]
